const { omit } = require('ramda')

module.exports = omit([ '_id', 'organizationId', 'createdBy', 'createdAt', 'editedBy', 'editedAt' ])
